<template>
  <div>
    <form :id="formId">
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('Security.client.startAddress')}}:</div>
              <input type="hidden" name="id" v-model="client.id"/>
              <input
                class="e-input e-input-group"
                :id="this.baseType+'startAddress'"
                name="startAddress"
                v-model="client.startAddress"
                maxlength="20"
                :placeholder="$t('Security.placeholder.startAddress')"
              />
            </div>
            <div class="error"></div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('Security.client.endAddress')}}:</div>
              <input
                class="e-input e-input-group"
                :id="this.baseType+'endAddress'"
                name="endAddress"
                v-model="client.endAddress"
                maxlength="20"
                :placeholder="$t('Security.placeholder.endAddress')"
              />
            </div>
            <div class="error"></div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';

export default {
  name: 'clientOption',
  props: {
    baseType: String
  },
  data () {
    return {
      formId: this.baseType+'clientForm',
      formValidator: '',
      client: {
        id: '',
        startAddress: '',
        endAddress: ''
      },
      validateOptions: {
        customPlacement: function (inputElement, errorElement) {
          inputElement = inputElement.closest('.form-group').querySelector('.error');
          inputElement.parentElement.appendChild(errorElement);
        },
        rules: {
          "startAddress": {
            required: [true, `${this.$t('Security.client.startAddress')}`],
            regex: ['^(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])$',`${this.$t('Security.validate.ip')}`],
          },
          'endAddress': {
            required: [true, `${this.$t('Security.client.endAddress')}`],
            regex: ['^(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d{1,2}|1\\d\\d|2[0-4]\\d|25[0-5])$',`${this.$t('Security.validate.ip')}`],
          },
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    init(id) {
      if (!!id) {
        const url = '/lte/ems/client/findById';
        let That = this;
        this.axios.get(url, {params: {id: id}}).then(response => {
          const result = response.data;
          That.client.id = result.id;
          That.client.startAddress = result.startAddress;
          That.client.endAddress = result.endAddress;
        });
      }
      this.formValidator = new FormValidator('#'+this.formId, this.validateOptions);
    },
    validation() {

      let result = true;
      result = this.formValidator.validate();
      let start_ip_arr = this.client.startAddress.split(".");
      let end_ip_arr = this.client.endAddress.split(".");
      let id = this.baseType+'endAddress';
      for (let index=0; index < 4; index++) {
        let s_i = start_ip_arr[index];
        let e_i = end_ip_arr[index];
        if (index < 3) {
          if (s_i != e_i) {
            this.setErrorMsg(id, `${this.$t('Security.validate.addressRangeErr')}`, 'add');
            result = false;
            break;
          }
        } else if (parseInt(s_i,10) > parseInt(e_i,10)) {
          this.setErrorMsg(id, `${this.$t('Security.validate.addressCompareErr')}`, 'add');
          result = false;
          break;
        } else {
          this.setErrorMsg(id, '', 'del')
        }
      }
      return result;
    },
    getParam() {
      let param = {
        startAddress: this.client.startAddress,
        endAddress: this.client.endAddress
      }
      if (!!this.client.id) {
        param['id'] = this.client.id;
      }
      return param;
    },
    setErrorMsg(id, msg, type) {
      if(type==='add') {
        document.getElementById(id).classList.add('e-error');
        document.getElementById(id).parentElement.nextElementSibling.className = 'e-error';
      }else {
        document.getElementById(id).classList.remove('e-error');
        document.getElementById(id).parentElement.nextElementSibling.className = 'error';
      }
      document.getElementById(id).parentElement.nextElementSibling.innerHTML = msg;
    }
  }
}
</script>
